import { create } from 'zustand';

type GuideStore = {
  isOpen: boolean;
  openGuide: () => void;
  closeGuide: () => void;
};

export const useGuideStore = create<GuideStore>(set => ({
  isOpen: false,
  openGuide: () => set({ isOpen: true }),
  closeGuide: () => set({ isOpen: false })
}));
